// extracted by mini-css-extract-plugin
export default {"error":"CInput_error__TX4wl","focused":"CInput_focused__XMtNI"};